import './lib/firebase';
import { useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { AuthGate } from './components/AuthGate';
import DynamicLocaleProvider from './context/DynamicLocaleProvider';
import { ThemeProvider } from './context/ThemeProvider';
import { UserProvider } from './context/UserContext';
import { pingBackend } from './lib/pingBackend';

export default function App() {
  useEffect(() => {
    pingBackend()
      .then((response) => {
        console.info('[craft] backend ping:', response);
      })
      .catch((error) => {
        console.warn('[craft] backend ping failed:', error);
      });
  }, []);

  return (
    <UserProvider>
      <DynamicLocaleProvider>
        <ThemeProvider>
          <BrowserRouter>
            <AuthGate />
          </BrowserRouter>
        </ThemeProvider>
      </DynamicLocaleProvider>
    </UserProvider>
  );
}
